import { formatNumber } from "lib/numbers";

export function formatSpreadPercentage(spreadValue: number, tokenPrice: number) {
  if (!Number.isFinite(spreadValue) || spreadValue <= 0 || !Number.isFinite(tokenPrice) || tokenPrice <= 0) {
    return "0.00%";
  }

  const percentage = (spreadValue / tokenPrice) * 100;
  if (percentage > 0 && percentage < 0.01) {
    return "<0.01%";
  }

  return `${formatNumber(percentage, {
    decimals: 2,
    isForceDecimal: true,
  })}%`;
}
